export const styles = {
  alert: (theme) => ({
    position: "absolute",
    bottom: 20,
    left: 20,
    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
    borderRadius: 2,
    maxWidth: 420,
    zIndex: 999999,
    backgroundColor: theme.palette.background.default,
  }),
  smashyCharacter: {
    width: 70,
    height: 70,
    objectFit: "contain",
  },
  message: (theme) => ({
    textAlign: "center",
    lineHeight: "1.28571429em",
    color: theme.palette.common.black,
  }),
  content: {
    alignItems: "center",
    p: 1,
    gap: 1,
  },
  button: {
    textTransform: "none",
    minWidth: 120,
    minHeight: 0,
    lineHeight: "1.15",
  },
  closeButton: {
    position: "absolute",
    right: 2,
    top: 0,
  },
  lottieContainer: {
    "& div": {
      margin: "0px!important",
    },
  },
}
